export default "__VITE_ASSET__BqZI5Wec__"